export { default as GeneralStepEditForm } from './GeneralStepEditForm';
export { default as DimensionsStepEditForm } from './DimensionsStepEditForm';
export { default as VirtualSKUStepEditForm } from './VirtualSKUStepEditForm';



// WEBPACK FOOTER //
// ./src/modules/product/wizard/forms/index.js